import React from 'react'
import { Layout } from './Layout'
import { Provider } from './Context'

export const CashPanel = ({ onPay }) => {
  return (
    <Provider {...{ onPay }}>
      <Layout />
    </Provider>
  )
}
